import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AurelixAIHero from "../sections/AurelixAIHero";
import AurelixAIServices from "../sections/AurelixAIServices";
import "./GrowthPage.css";

export default function AurelixAIPage() {
  return (
    <>
      <Navbar />
      <main className="growth-main">
        <AurelixAIHero />
        <AurelixAIServices />
      </main>
      <Footer />
    </>
  );
}
